export default __webpack_public_path__ + "static/media/google-cloud-platform-k8s-engine.6bbc63e3174f2fea527712e547e610bd.svg";